<template>
  <div>
    <!-- Buttons Navigation -->
    <div class="mt-3">
      <v-btn-toggle v-model="rightNavigationOption">
        <v-btn flat>
          <v-icon>format_list_bulleted</v-icon>
        </v-btn>
        <v-btn flat>
          <v-icon>assessment</v-icon>
        </v-btn>
        <v-btn 
          :disabled="!match.setsTableData.playersStats.withValues"
          flat>
          <v-icon>perm_identity</v-icon>
        </v-btn>
        <v-btn flat>
          <v-icon>timeline</v-icon>
        </v-btn>
        <v-btn flat>
          <v-icon>assignment</v-icon>
        </v-btn>
      </v-btn-toggle>
    </div>
    <!-- Right Navigation -->
    <div>
      <v-navigation-drawer
        :value="rightNavigationOption!==null"
        :permanent="rightNavigationOption!==null"
        fixed
        touchless
        right
        app
        disable-resize-watcher
        width="550">
        <v-list class="pa-1">
          <v-list-tile 
            avatar 
            tag="div">
            <v-list-tile-content>
              <v-list-tile-title>
                <h2 v-if="rightNavigationOption===0">{{ $t('page.match.leyend') }}</h2>
                <h2 v-if="rightNavigationOption===1">{{ $t('page.match.setStats',{type:getType(match.type)}) }}</h2>
                <h2 v-if="rightNavigationOption===2">{{ $t('page.match.playerStats') }}</h2>
                <h2 v-if="rightNavigationOption===3">{{ $t('page.match.graphs') }}</h2>
                <h2 v-if="rightNavigationOption===4">{{ $t('page.match.summary') }}</h2>
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn 
                icon 
                @click.stop="rightNavigationOption=null">
                <v-icon>close</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        
        <v-layout 
          v-if="match.sport.name" 
          wrap
          px-1
          row >
          <v-flex 
            class="text-xs-center subheading text--grey"
            xs12>
            <span class="grey--text"><small>{{ $t(`sport.types.${match.sport.name}.name`) }}</small></span>
          </v-flex>
        </v-layout>
        <!-- Team Names -->
        <v-layout 
          :style="{color:style.primary}"
          wrap
          px-1
          row >
          <v-flex 
            xs12
            class="team text-xs-center title" >
            <v-layout row wrap>
              <v-flex xs6>
                <img 
                  v-if="match.localTeamLogo"
                  :src="match.localTeamLogo" 
                  class="logo-container-info">
                <br>
                <span :class="{winner:match.winnerLocal, loser:match.winnerVisitor}">
                  <span v-if="match.localTeam">{{ match.localTeam }}</span>
                  <span v-else >{{ $t('entity.match.localTeam.label') }}</span>
                </span>
              </v-flex>
              <v-flex xs6>
                <img 
                  v-if="match.visitorTeamLogo"
                  :src="match.visitorTeamLogo" 
                  class="logo-container-info">
                <br>
                <span :class="{winner:match.winnerVisitor, loser:match.winnerLocal}">
                  <span v-if="match.visitorTeam">{{ match.visitorTeam }}</span>
                  <span v-else>{{ $t('entity.match.visitorTeam.label') }}</span>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- Category -->
        <v-layout 
          wrap
          px-1
          row >
          <v-flex 
            xs12
            class="text-xs-center subheading" >
            <span v-if="match.category">{{ match.category }}</span>
            <span 
              v-else
              class="placeholder">{{ $t('entity.match.category.label') }}</span>
          </v-flex>
        </v-layout>
        <!-- Score -->
        <v-layout 
          row
          wrap
          mx-2>
          <v-flex 
            :class="match.started?'xs5':'xs6'">
            <v-card 
              :color="getScoreColor('l')" 
              class="display-2" 
              dark>
              {{ match.totalScoreLocal }}
            </v-card>
          </v-flex>
          <v-flex 
            v-if="match.started" 
            xs2 
            class="text-xs-center caption grey--text">
            <v-layout 
              v-for="(set,i) in match.sets" 
              v-if="set.l>0 || set.v>0"
              :key="`setheader_${i}`" 
              my-0
              py-0
              wrap 
              row>
              <v-flex 
                class="text-xs-right"
                xs5 
                my-0 
                py-0>{{ set.l }}</v-flex>
              <v-flex 
                xs2
                my-0
                py-0>-</v-flex>
              <v-flex 
                class="text-xs-left"
                xs5
                my-0
                py-0>{{ set.v }}</v-flex>
            </v-layout>
          </v-flex>
          <v-flex 
            :class="match.started?'xs5':'xs6'">
            <v-card 
              :color="getScoreColor('v')" 
              class="display-2"
              dark>
              {{ match.totalScoreVisitor }}
            </v-card>
          </v-flex>
        </v-layout>
        <!-- LEYEND -->
        <div v-if="rightNavigationOption===0">
          <div class="rightPanel">
            <Leyend 
              :match="match"
              :mode="mode"/>
          </div>
        </div>
        <!-- Sets Stats -->
        <div v-if="rightNavigationOption===1">
          <div class="rightPanel">
            <AdvancedStats 
              :match="match"
              :mode="mode"/>
          </div>
        </div>
        <!-- Player Sets Stats -->
        <div v-if="rightNavigationOption===2">
          <div class="rightPanel">
            <PlayerStats
              :match="match"
              :mode="mode"/>
          </div>
        </div>
        <!-- SLOT Graphs -->
        <div v-if="rightNavigationOption===3">
          <div class="rightPanel">
            <MatchCharts :match="match" />
          </div>
        </div>
        <!-- Summary -->
        <div v-if="rightNavigationOption===4">
          <div class="rightPanel">
            <Summary :match="match" />
          </div>
        </div>
      </v-navigation-drawer>
    </div>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import MatchCharts from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/MatchCharts'
import AdvancedStats from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Stats/AdvancedStats'
import PlayerStats from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Stats/PlayerStats'
import Leyend from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Leyend'
import Summary from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Summary'

// const debug = require('debug')('OD::BoardInfo')

export default {
  name: 'BoardInfo',
  components: { Summary, MatchCharts, PlayerStats, AdvancedStats, Leyend },
  props: {
    match: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rightNavigationOption: null,
    }
  },
  computed: {
    ...mapState({
      mode: state => state.global.boardMode,
      style: state => state.style.style,
    }),
  },
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {
    getScoreColor(team) {
      if (this.match.isFinish) {
        if (this.match.totalScoreLocal === this.match.totalScoreVisitor) {
          return 'light-green'
        }
        if (team === 'l') {
          return this.match.totalScoreLocal > this.match.totalScoreVisitor ? 'green' : 'grey'
        }
        return this.match.totalScoreVisitor > this.match.totalScoreLocal ? 'green' : 'grey'
      }
      return 'grey'
    },
    getType(type) {
      switch (type) {
        case 'pointBase':
          return 'set'
        case 'timeBase':
          return 'period'
        case 'baseballBase':
          return 'inning'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .xs-d-block {
    display: block;
  }
}
.logo-container {
  max-width: 100%;
  overflow-y: hidden;
  display: block;
  img {
    max-height: 40px;
  }
}
.uppercase {
  text-transform: uppercase;
}

.team-name {
  text-transform: uppercase;
  font-weight: bold;
  color: grey;
}

.text-bigger {
  font-size: 1.3em;
  font-weight: bold;
}

.tiebreak-icon {
  width: 20px;
}

.blink_me {
  animation: blinker 3s linear infinite;
}

.blink_me_color {
  animation: blinker_color 3s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}

@keyframes blinker_color {
  50% {
    color: #aaa;
  }
}

.sets-summary {
  th {
    padding: 0 5px;
    background-color: #ddd;
  }
  th.white {
    background-color: #fff;
  }
  td {
    background-color: #f8f8f8;
    text-align: center;
  }
  th.odd,
  td.odd {
    background-color: #f0f0f0;
  }
  th.even,
  td.even {
    background-color: #f8f8f8;
  }
  td.bold {
    font-weight: bold;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  border: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
}

.card__text.small {
  padding: 8px 3px 3px 3px;
}

.rightPanel {
  text-align: left;
  padding: 24px;
}

.team {
  /*
  .winner {
  }
  */
  .loser {
    font-weight: lighter;
  }
}
.logo-container-info {
  max-width: 60px;
}
</style>

